import type { QueryParameterConfig } from '@pba/react-router';
import { type ChatroomListType, isChatroomListType } from 'features/chat';

// eslint-disable-next-line @typescript-eslint/naming-convention -- need to be renamed to not eslint error
export const ChatroomListTypeParameter = {
  decode(value?: Array<null | string> | null | string) {
    if (isChatroomListType(value)) {
      return value;
    }

    return undefined;
  },

  default: undefined,
  encode(value?: ChatroomListType) {
    if (!value || value === 'all') {
      return undefined;
    }

    return value;
  },
} satisfies QueryParameterConfig<ChatroomListType | undefined>;
